import { createApp } from 'vue';
import { createPinia } from 'pinia';

// Packages
import axios from 'axios';
import persistedState from 'pinia-plugin-persistedstate';
import { VueQueryPlugin } from 'vue-query';

import App from './App.vue';
import router from './router';

// Plugins
import interceptors from 'plugins/interceptors';

// Polyfills
import { Buffer } from 'buffer';
window.Buffer = Buffer; // Polyfill for Buffer

const store = createPinia();
const app = createApp(App);

// Persisted State
store.use(persistedState);

// API interceptors
interceptors(axios);

app.use(store).use(router).use(VueQueryPlugin).mount('#app');
